const ENERGY_LABEL_RANK = {
  A: 1,
  B: 2,
  C: 3,
  D: 4,
  E: 5,
  F: 6,
  G: 7,
};

export function normalizeEnergyLabel(labelValue) {
  const normalized = (String(labelValue || "").trim().toUpperCase().match(/[A-G]/) || [])[0];
  return normalized || null;
}

export function getEnergyLabelRank(labelValue) {
  const normalized = normalizeEnergyLabel(labelValue);
  if (!normalized) {
    return null;
  }
  return ENERGY_LABEL_RANK[normalized] || null;
}

export function isEnergyLabelAtMost(labelValue, maxLabel = "D", options = {}) {
  const { missingAsPass = false } = options;
  const labelRank = getEnergyLabelRank(labelValue);
  const maxRank = getEnergyLabelRank(maxLabel);

  if (!maxRank) {
    return false;
  }

  if (!labelRank) {
    return missingAsPass;
  }

  // Higher rank means lower energy performance (E/F/G), so allowed for "D or lower".
  return labelRank >= maxRank;
}

export function isEnergyLabelBetterThan(labelValue, thresholdLabel = "D") {
  const labelRank = getEnergyLabelRank(labelValue);
  const thresholdRank = getEnergyLabelRank(thresholdLabel);

  if (!labelRank || !thresholdRank) {
    return false;
  }

  return labelRank < thresholdRank;
}
